<app-header></app-header>

<div class="bg-custom">
  <div class="">
      <router-outlet></router-outlet>
  </div>
</div>

<app-footer></app-footer>